import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import logo from "../images/catalyst/logo.png";
import LinkCard from "../components/catalyst/LinkCard";
import Countdown from "react-countdown";
import ReactGA from "react-ga";

const Catalyst = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  const logoRef = useRef(null);
  const titleRef = useRef(null);

  const spinLogo = (e) => {
    ReactGA.event({
      category: "CATALYST",
      action: "easter_egg",
      label: "easter_egg_l",
    });

    gsap.fromTo(
      "#catalyst-logo",
      {
        rotate: "0",
      },
      {
        rotate: "-360",
        duration: 2,
        ease: "expo.inOut",
      }
    );

    gsap.fromTo(
      "#catalyst-logo",
      1,
      {
        scale: 1,
      },
      {
        scale: 1.1,
        yoyo: true,
        repeat: 1,
        duration: 1,
        ease: "expo.in",
      },
      "<"
    );
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);

    gsap.set(".link-card", {
      autoAlpha: 0,
      scale: 0.6,
      y: 40,
    });

    gsap.set(".countdown", {
      autoAlpha: 0,
      y: 60,
    });

    let t1 = gsap.timeline({ repeat: 0 });

    t1.from(logoRef.current, {
      rotate: 100,
      ease: "expo.inOut",
      autoAlpha: 0,
      scale: 0.5,
      y: 100,
      duration: 2,
    });

    t1.from(
      titleRef.current,
      {
        ease: "expo.inOut",
        autoAlpha: 0,
        y: 80,
        duration: 2,
      },
      "<"
    );

    t1.to(
      ".countdown",
      {
        y: 0,
        ease: "expo.out",
        scale: 1,
        autoAlpha: 1,
        duration: 1,
        delay: 1,
      },
      "<"
    );

    t1.to(".link-card", {
      y: 0,
      ease: "expo.inOut",
      scale: 1,
      autoAlpha: 1,
      duration: 1.5,
      delay: -1.7,
      stagger: 0.1,
    });
  }, []);

  const Completionist = () => <span></span>;

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-10">
        <img
          src={logo}
          alt="catalyst-logo"
          ref={logoRef}
          id="catalyst-logo"
          className="w-40 el"
          style={styles.hidden}
          onClick={(e) => spinLogo(e)}
        />
        <div
          className="mt-4 text-5xl"
          ref={titleRef}
          style={{ ...styles.hidden, fontFamily: "catalyst" }}
        >
          CATALYST 2021
        </div>

        {/*
        <div
          className="my-2 text-3xl font-thin countdown"
          style={{ fontFamily: "monospace", color: "#f00" }}
        >
          <Countdown date={"2021-07-23T09:00:00"}>
            <Completionist />
          </Countdown>
        </div> */}
      </div>

      <div className="w-full max-w-md m-auto mt-4 mb-10 px-4">
        <LinkCard
          title="📕 Delegate Booklet"
          color="#f00"
          newTab={true}
          link="https://drive.google.com/file/d/1okpV3BXOJylYRIFVp7rbrfz1jady0gQd/view"
        />

        <LinkCard
          title="📅 Agenda"
          color="#FFC845"
          newTab={false}
          link="/catalyst/agenda"
        />

        <LinkCard
          title="1️⃣ Day 1 Plenary"
          color="#037ef3"
          newTab={true}
          link="https://www.aiesec.lk/catalyst2021-day1"
        />
        <LinkCard
          title="2️⃣ Day 2 Plenary"
          color="#037ef3"
          newTab={false}
          link="/catalyst/day2"
        />

        <LinkCard
          title="💘 Love Guru"
          color="#7552CC"
          newTab={true}
          link="https://forms.gle/JmvKoExpdx9mzrMg8"
        />

        <LinkCard
          title="🎵 Spotify Playlist"
          color="#00C16E"
          newTab={true}
          link="http://bit.ly/catalyst2021-officialplaylist"
        />

        {
          <LinkCard
            title="🎁 Sugar Cubes"
            color="#0CB9C1"
            newTab={false}
            link="/catalyst/sugarcubes"
          />
        }
      </div>
    </div>
  );
};

export default Catalyst;
